// src/PdfViewerComponent.js
import React, { useEffect, useRef } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";

// Import styles
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import "@react-pdf-viewer/search/lib/styles/index.css";
import { IconButton } from "@chakra-ui/react";

import DownloadIcon from "@mui/icons-material/Download";

function PdfViewerComponent({
  file1,
  file2,
  pageNumber,
  searchPluginInstance,
  zoomPluginInstance,
  syncScroll,

  zoomPluginInstance2,
}) {
  const pageNavigationPluginInstance = pageNavigationPlugin();

  const pageNavigationPluginInstance2 = pageNavigationPlugin();

  const { jumpToPage } = pageNavigationPluginInstance;

  const { jumpToPage: jumpToPage2 } = pageNavigationPluginInstance2;

  // const fileUrl = useMemo(() => URL.createObjectURL(file1), [file1]);

  const viewerRef1 = useRef(null);
  const viewerRef2 = useRef(null);

  useEffect(() => {
    jumpToPage(pageNumber);
    jumpToPage2(pageNumber);
  }, [pageNumber]);
  useEffect(() => {
    if (syncScroll) {
      const scroll_other = viewerRef2.current.querySelector(
        '[data-testid="core__inner-pages"]'
      );
      const scroll_other2 = viewerRef1.current.querySelector(
        '[data-testid="core__inner-pages"]'
      );

      try {
        scroll_other2.scrollTop = 0;
        scroll_other.scrollTop = 0;
      } catch (e) {
        console.log("error");
      }
    }
  }, [syncScroll]);
  return (
    <div className="flex justify-center w-full ">
      <div className="flex justify-between w-full">
        <div
          ref={viewerRef1}
          className=""
          style={{
            width: "50vw",
            height: "800px",
          }}
          onScrollCapture={(e) => {
            if (syncScroll) {
              const scroll_other = viewerRef2.current.querySelector(
                '[data-testid="core__inner-pages"]'
              );

              try {
                scroll_other.scrollTop = e.target.scrollTop;
              } catch (e) {
                console.log("error");
              }
            }
          }}
        >
          <div className=" flex flex-row justify-between px-12">
            <h4 className="font-semibold text-center text-gray-500 my-auto ">
              Old File
            </h4>

            <IconButton
              variant="ghost"
              onClick={() => {
                const link = document.createElement("a");
                link.href = file1;
                link.download = "file1.pdf";
                link.target = "_blank";
                link.click();
              }}
              icon={
                <div className="text-gray-500">
                  <DownloadIcon />
                </div>
              }
            />
          </div>
          <Worker
            workerUrl={`https://unpkg.com/pdfjs-dist@2.11.338/build/pdf.worker.min.js`}
          >
            <Viewer
              fileUrl={file1}
              plugins={[
                pageNavigationPluginInstance,
                searchPluginInstance,
                zoomPluginInstance,
              ]}
            ></Viewer>
          </Worker>
        </div>
        <div
          className=""
          style={{
            width: "50vw",
            height: "800px",
          }}
          ref={viewerRef2}
          onScrollCapture={(e) => {
            if (syncScroll) {
              const scroll_other = viewerRef1.current.querySelector(
                '[data-testid="core__inner-pages"]'
              );

              try {
                scroll_other.scrollTop = e.target.scrollTop;
              } catch (e) {
                console.log("error");
              }
            }
          }}
        >
          <div className="flex flex-row justify-between  px-12 ">
            <h4 className="font-semibold text-center text-gray-500 my-auto ">
              New File
            </h4>
            <IconButton
              variant="ghost"
              onClick={() => {
                const link = document.createElement("a");
                link.href = file2;
                link.download = "file2.pdf";
                link.target = "_blank";
                link.click();
              }}
              icon={
                <div className="text-gray-500">
                  <DownloadIcon />
                </div>
              }
            />
          </div>
          <Worker
            workerUrl={`https://unpkg.com/pdfjs-dist@2.11.338/build/pdf.worker.min.js`}
          >
            <Viewer
              fileUrl={file2}
              plugins={[pageNavigationPluginInstance2, zoomPluginInstance2]}
            />
          </Worker>
        </div>
      </div>
    </div>
  );
}

export default PdfViewerComponent;
